export const FACE_CLAIM_AGE_GROUPS = {
  ALL: 'all',
  '18-23': '18-23',
  '24-31': '24-31',
  '32-41': '32-41',
  '42-60': '42-60',
} as const;

export type FaceClaimAgeGroup = (typeof FACE_CLAIM_AGE_GROUPS)[keyof typeof FACE_CLAIM_AGE_GROUPS];

export const AGE_GROUP_LABELS: Record<FaceClaimAgeGroup, string> = {
  all: 'All ages',
  '18-23': '18-23',
  '24-31': '24-31',
  '32-41': '32-41',
  '42-60': '42–60',
};
